import DummyImg from 'assets/dummy/dummy-1.png';
import DummyScroll1 from 'assets/dummy/dummy-scroll-1.png';

const StyleOrder = () => {
  return (
    <div className="px-4 pt-6 pb-[150px] lg:mt-10 lg:w-[95%] lg:max-w-[95%] lg:self-start lg:rounded-2xl lg:p-8 lg:shadow-order">
      <p className="text-base font-semibold text-primary-black">
        Choose your style
      </p>

      <div className="mt-6 flex-row-reverse overflow-hidden rounded-xl bg-background-light-blue px-6 pt-6 pb-3 lg:flex lg:max-h-[747px] lg:justify-around lg:pt-10 lg:pb-10">
        <div>
          <div className="flex items-center justify-between">
            <p className="text-xs text-primary-black">Preview</p>
            <p className="text-xs font-bold text-primary-black">Layout #1</p>
          </div>
          <div className="mt-3 h-[408px] rounded-lg border border-secondary-light-blue lg:mt-4 lg:h-[636px]">
            <img alt="" src={DummyImg} className="h-full w-full" />
          </div>
        </div>

        <div className="mr-10 lg:overflow-hidden">
          <div className="mt-8 flex items-center justify-between lg:mt-0">
            <p className="text-xs text-primary-black">Available layout</p>
            <p className="text-xs font-bold text-primary-black">1/12</p>
          </div>
          <div className="mt-3 flex items-center overflow-scroll pb-3 lg:mt-4 lg:flex-col lg:overflow-y-scroll">
            <div className="relative mr-3 h-20 w-20 min-w-[80px] rounded-lg border border-primary-light-blue lg:mb-3 lg:mr-0 lg:min-h-[128px] lg:min-w-[128px]">
              <div className="absolute h-full w-full rounded-lg bg-black/40" />
              <img
                alt=""
                src={DummyScroll1}
                className="h-full w-full rounded-lg"
              />
            </div>
            <div className="relative mr-3 h-20 w-20 min-w-[80px] rounded-lg border-primary-light-blue lg:mb-3 lg:mr-0 lg:min-h-[128px] lg:min-w-[128px]">
              <div className="absolute h-full w-full rounded-lg bg-black/40" />

              <img
                alt=""
                src={DummyScroll1}
                className="h-full w-full rounded-lg"
              />
            </div>
            <div className="relative mr-3 h-20 w-20 min-w-[80px] rounded-lg border-primary-light-blue lg:mb-3 lg:mr-0 lg:min-h-[128px] lg:min-w-[128px]">
              <div className="absolute h-full w-full rounded-lg bg-black/40" />

              <img
                alt=""
                src={DummyScroll1}
                className="h-full w-full rounded-lg"
              />
            </div>
            <div className="relative mr-3 h-20 w-20 min-w-[80px] rounded-lg border-primary-light-blue lg:mb-3 lg:mr-0 lg:min-h-[128px] lg:min-w-[128px]">
              <div className="absolute h-full w-full rounded-lg bg-black/40" />

              <img
                alt=""
                src={DummyScroll1}
                className="h-full w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StyleOrder;
